import img_table from "../../../../assets/images/chartable.png";
import { useEffect, useState } from "react";
import { twelveChar } from "../../../../util";
import GroupHeader from "../GroupHeader";
import "./index.css";

function GroupCharacter({
  userdata,
  groupinfo,
  total,
  page,
  facilitatorUsers,
  advisorUsers,
  mediatorUsers,
  visionaryUsers,
  innovatorUsers,
  adventurerUsers,
  analystUsers,
  strategistUsers,
  evaluatorUsers,
  plannerUsers,
  scholarUsers,
  guardianUsers,
}) {
  const [countData, setCountData] = useState([]);

  useEffect(() => {
    let count = {
      촉진자: 0,
      상담가: 0,
      중재자: 0,
      비전가: 0,
      발명가: 0,
      모험가: 0,
      분석가: 0,
      전략가: 0,
      비평가: 0,
      설계자: 0,
      학자: 0,
      수호자: 0,
    };
    userdata.map((user) => {
      count = {
        ...count,
        [user.subType]: (count[user.subType] || 0) + 1,
      };
    });
    setCountData(count);
  }, [userdata]);

  const getTypeColor = (type) => {
    if (type === "촉진자") return "red";
    else if (type === "상담가") return "orange";
    else if (type === "중재자") return "yellowgreen";
    else if (type === "비전가") return "lime";
    else if (type === "발명가") return "darkgreen";
    else if (type === "모험가") return "skyblue";
    else if (type === "분석가") return "blue";
    else if (type === "전략가") return "purple";
    else if (type === "비평가") return "salmon";
    else if (type === "설계자") return "pink";
    else if (type === "학자") return "navy";
    else if (type === "수호자") return "peru";
    else return "gray";
  };

  return (
    <div className="GroupCharacter page">
      <GroupHeader groupinfo={groupinfo} total={total} />
      <h1 style={{ marginLeft: "1.5rem" }}>
        {groupinfo.groupname} 그룹의 캐릭터 분포 Raw Data
      </h1>
      <div className="table-container">
        <img alt="" src={img_table} />
      </div>
      <div
        style={{
          width: "97%",

          margin: "0 auto",
        }}
      >
        <div className="percentage">
          {twelveChar.map((type) => (
            <div className="percent-container" key={type.name}>
              <span
                style={{
                  textAlign: "left",
                  color: getTypeColor(type.name),
                  marginRight: "0.5rem",
                }}
              >
                ● {type.name}
              </span>
              {/* <br /> */}
              <b style={{ textAlign: "center" }}>
                {Math.round(
                  (countData[type.name] / userdata.length) * 100 * 10
                ) / 10}
                %
              </b>
            </div>
          ))}
        </div>
      </div>
      <div className="user-container-old-parents">
        <div className="user-container-parents">
          <div className="user-container">
            {Array.from({ length: facilitatorUsers.length }).map((_, index) => (
              <div className="user" key={index}>
                <div key={index}>
                  {
                    <>
                      <span
                        style={{
                          color: getTypeColor("촉진자"),
                          marginRight: "0.5rem",
                        }}
                      >
                        ●
                      </span>
                      {facilitatorUsers[index]}
                    </>
                  }
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="user-container-parents">
          <div className="user-container">
            {Array.from({ length: advisorUsers.length }).map((_, index) => (
              <div className="user" key={index}>
                <div key={index}>
                  {
                    <>
                      <span
                        style={{
                          color: getTypeColor("상담가"),
                          marginRight: "0.5rem",
                        }}
                      >
                        ●
                      </span>
                      {advisorUsers[index]}
                    </>
                  }
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="user-container-parents">
          <div className="user-container">
            {Array.from({ length: mediatorUsers.length }).map((_, index) => (
              <div className="user" key={index}>
                <div key={index}>
                  {
                    <>
                      <span
                        style={{
                          color: getTypeColor("중재자"),
                          marginRight: "0.5rem",
                        }}
                      >
                        ●
                      </span>
                      {mediatorUsers[index]}
                    </>
                  }
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="user-container-parents">
          <div className="user-container">
            {Array.from({ length: visionaryUsers.length }).map((_, index) => (
              <div className="user" key={index}>
                <div key={index}>
                  {
                    <>
                      <span
                        style={{
                          color: getTypeColor("비전가"),
                          marginRight: "0.5rem",
                        }}
                      >
                        ●
                      </span>
                      {visionaryUsers[index]}
                    </>
                  }
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="user-container-parents">
          <div className="user-container">
            {Array.from({ length: innovatorUsers.length }).map((_, index) => (
              <div className="user" key={index}>
                <div key={index}>
                  {
                    <>
                      <span
                        style={{
                          color: getTypeColor("발명가"),
                          marginRight: "0.5rem",
                        }}
                      >
                        ●
                      </span>
                      {innovatorUsers[index]}
                    </>
                  }
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="user-container-parents">
          <div className="user-container">
            {Array.from({ length: adventurerUsers.length }).map((_, index) => (
              <div className="user" key={index}>
                <div key={index}>
                  {
                    <>
                      <span
                        style={{
                          color: getTypeColor("모험가"),
                          marginRight: "0.5rem",
                        }}
                      >
                        ●
                      </span>
                      {adventurerUsers[index]}
                    </>
                  }
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="user-container-parents">
          <div className="user-container">
            {Array.from({ length: analystUsers.length }).map((_, index) => (
              <div className="user" key={index}>
                <div key={index}>
                  {
                    <>
                      <span
                        style={{
                          color: getTypeColor("분석가"),
                          marginRight: "0.5rem",
                        }}
                      >
                        ●
                      </span>
                      {analystUsers[index]}
                    </>
                  }
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="user-container-parents">
          <div className="user-container">
            {Array.from({ length: strategistUsers.length }).map((_, index) => (
              <div className="user" key={index}>
                <div key={index}>
                  {
                    <>
                      <span
                        style={{
                          color: getTypeColor("전략가"),
                          marginRight: "0.5rem",
                        }}
                      >
                        ●
                      </span>
                      {strategistUsers[index]}
                    </>
                  }
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="user-container-parents">
          <div className="user-container">
            {Array.from({ length: evaluatorUsers.length }).map((_, index) => (
              <div className="user" key={index}>
                <div key={index}>
                  {
                    <>
                      <span
                        style={{
                          color: getTypeColor("비평가"),
                          marginRight: "0.5rem",
                        }}
                      >
                        ●
                      </span>
                      {evaluatorUsers[index]}
                    </>
                  }
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="user-container-parents">
          <div className="user-container">
            {Array.from({ length: plannerUsers.length }).map((_, index) => (
              <div className="user" key={index}>
                <div key={index}>
                  {
                    <>
                      <span
                        style={{
                          color: getTypeColor("설계자"),
                          marginRight: "0.5rem",
                        }}
                      >
                        ●
                      </span>
                      {plannerUsers[index]}
                    </>
                  }
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="user-container-parents">
          <div className="user-container">
            {Array.from({ length: scholarUsers.length }).map((_, index) => (
              <div className="user" key={index}>
                <div key={index}>
                  {
                    <>
                      <span
                        style={{
                          color: getTypeColor("학자"),
                          marginRight: "0.5rem",
                        }}
                      >
                        ●
                      </span>
                      {scholarUsers[index]}
                    </>
                  }
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="user-container-parents">
          <div className="user-container">
            {Array.from({ length: guardianUsers.length }).map((_, index) => (
              <div className="user" key={index}>
                <div key={index}>
                  {
                    <>
                      <span
                        style={{
                          color: getTypeColor("수호자"),
                          marginRight: "0.5rem",
                        }}
                      >
                        ●
                      </span>
                      {guardianUsers[index]}
                    </>
                  }
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default GroupCharacter;
